<template>
  <div class="giveaway-success">
    <img
      src="/common/nexus/green-check-mark.png"
      alt=""
      class="giveaway-success__image"
    >
    <h2 class="giveaway-success__heading heading--3">
      You're in!
    </h2>
    <p class="giveaway-success__copy">Thank you for entering. Winner(s) will be notified via email.</p>
    <a
      v-if="showGiveawayDetailsLink"
      :href="giveawayDetails"
      target="_blank"
      class="giveaway-success__cta"
    >
      View giveaway details
      <icon-component
        name="caret"
        title="caret icon"
        class="giveaway-success__icon icon--small"
      />
    </a>
  </div>
</template>

<script>
export default {
  name: 'GiveawaySuccess',
  props: {
    giveawayDetails: {
      type: String,
      required: true,
    },
  },
  computed: {
    showGiveawayDetailsLink() {
      return window.location.href !== this.giveawayDetails;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/stylesheets/components/_giveaway-success';
</style>
